import { GTM_EVENTS } from '@hero/constants';

import { getBrowserUUID, getDevice, getPage } from './utils';

export function customEvent({ page, eventType, ...data }) {
  const selectedEventData = GTM_EVENTS[eventType];

  const eventData = {
    ...selectedEventData,
    pageType: page,
    timestamp: new Date().toISOString(),
    page: getPage({ page: data.page }),
    device: getDevice(),
    browserUUID: getBrowserUUID(),
    ...data
  };

  window.dataLayer.push(eventData);
}
